import React, {FC, useState} from "react";
import ReactDOM from "react-dom";
import qs from "query-string";

import "creator/dist/creator.esm.css";
import * as Creator from "creator";
import {ReactComponent as IconCart} from "../shop/modules/creator/views/assets/icons/cart.svg";
import {ReactComponent as IconSave} from "../shop/modules/creator/views/assets/icons/save.svg";

declare global {
  interface Window {
    cartURL: string;
    cartController: string;
    prestashop: any;
  }
}

type Action = "create" | "modify" | "duplicate";

function parseAction(action: any): Action {
  switch (action) {
    case "modify":
    case "duplicate":
      return action;

    default:
      return "create";
  }
}

async function parseConfig(config: any): Promise<Record<string, any>> {
  try {
    const url = atob(config);
    const res = await fetch(url).then(res => {
      if (!res.ok) throw new Error(res.statusText);
      return res.text();
    });
    return JSON.parse(res);
  } catch (err) {
    return {};
  }
}

window.addEventListener("DOMContentLoaded", async () => {
  const params = qs.parse(window.location.search, {parseNumbers: true});
  const customizationId = typeof params.customization === "number" ? params.customization : 0;
  const templateId = typeof params.template === "number" ? params.template : undefined;
  const productId = typeof params.product === "number" ? params.product : undefined;
  const step = typeof params.step === "number" ? params.step : undefined;
  const action = parseAction(params.action);
  const config = await parseConfig(params.config);

  ReactDOM.render(
    <Creator.App
      productId={productId}
      templateId={templateId}
      step={step}
      config={config}
      submitComponent={props => {
        const [loading, setLoading] = useState(false);

        async function deleteFromCart() {
          const query = {customization: customizationId.toString()};
          const url = qs.stringifyUrl({url: window.cartController, query});
          await fetch(url, {method: "DELETE"});
        }

        async function addToCart(body: string) {
          await fetch(window.cartController, {
            method: "POST",
            body,
          });
          window.location.href = window.prestashop.urls.pages.cart + "?action=show";
        }

        function renderSubmitLabel() {
          switch (action) {
            case "create":
            case "duplicate":
              return (
                <>
                  <IconCart className="creator-footer-submit-btn-icon" />
                  Ajouter au panier
                </>
              );
            case "modify":
              return (
                <>
                  <IconSave className="creator-footer-submit-btn-icon" />
                  Valider la modification
                </>
              );
          }
        }

        async function submit() {
          if (loading) return;
          setLoading(true);
          const body = await props.onSubmit();
          if (action === "modify") await deleteFromCart();
          console.log(body);
          await addToCart(JSON.stringify(body));
        }

        return (
          <div className="creator-footer">
            {action !== "create" && <a href={window.prestashop.urls.pages.cart + "?action=show"}>Annuler</a>}
            <button className="creator-footer-submit-btn" onClick={submit} disabled={loading}>
              {loading ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="creator-footer-submit-btn-icon creator-footer-submit-loader"
                  viewBox="0 0 24 24"
                  fill="#000000"
                >
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                </svg>
              ) : (
                renderSubmitLabel()
              )}
            </button>
          </div>
        );
      }}
    />,
    document.getElementById("root"),
  );
});
